import styled from "@emotion/styled";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Collage from "./Collage";
import Player from "./Components/Player/Player";
import Logo from "./images/logo512.png";
import TumannyyVideo from "./Pages/TumannyyVideo";

const StyledApp = styled.div``;

function App() {
  return (
    <StyledApp>
      <Router>
        <Switch>
          <Route path="/x3x3x">
            <Collage />
          </Route>
          <Route path="/">
            <Player />
          </Route>
        </Switch>
      </Router>
    </StyledApp>
  );
}

export default App;

// Ich entziehe mich deiner Anziehungskraft.
// Foggy ich sehne mich nach deiner Anziehungskraft
// Do you know what they did at the WBA?
// We invested in America.
// People are all twisted freaks.
// Der Traum ist hin.
// Der neue gott ist das internet
// Und auch dieser gott wird sterblich sein
// Das es jemanden gibt der unsere Probleme lösst.
